module.exports = __webpack_public_path__ + "static/about-content-image-6@2x-82e438a4edf1ce33b68a36ff7686cfc6.jpg";